import { render, staticRenderFns } from "./Ordenpago.vue?vue&type=template&id=f9c196a6&"
import script from "./Ordenpago.vue?vue&type=script&lang=js&"
export * from "./Ordenpago.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports